import React from "react";
import ResponsiveExpertiseCard from "./ResponsiveExpertiseCard";

const ResponsiveExpertrise = ({ data }) => {
  return (
    <div>
      {data?.map((v, i) => {
        return (
          <ResponsiveExpertiseCard
            key={i}
            index={i}
            image={v.image_url}
            heading={v.heading}
            description={v.description}
          />
        );
      })}
    </div>
  );
};

export default ResponsiveExpertrise;
